import {ClickTrackingLabels, FeatureTrackingLabels, TileFeature, Feature} from "./types";

export class TrackingService {

    sendViewTrackingEvent(featureOrder: number, featureIndex: number, featureTrackingTileLabels: FeatureTrackingLabels): void {
        const trackingData = [
            this._createTopicPromoFeature(featureOrder, featureIndex, "loaded"),
            this._createTopicPromoTileFeature(featureIndex, featureTrackingTileLabels, "loaded")
        ];
        window.o_global.eventQBus.emit('tracking.bct.addFeaturesToPageImpression', trackingData);
    }

    sendClickTrackingEvent(featureOrder: number, featureIndex: number, featureTrackingTileLabels: FeatureTrackingLabels, comboType: string | null): void {
        const featureTrackingData = {
            name: "click",
            features: [
                this._createTopicPromoFeature(featureOrder, featureIndex, "clicked"),
                this._createTopicPromoTileFeature(featureIndex, featureTrackingTileLabels, "clicked")]
        }
        const labelTrackingData = this._buildClickTrackingLabels(featureTrackingTileLabels, comboType);
        window.o_global.eventQBus.emit('tracking.bct.submitMoveAction', labelTrackingData, featureTrackingData);
        window.o_global.eventQBus.emit("tracking.bct.trackOnNextPageImpression", {"promo_Click": "TopicPromotionLarge"})
    }

    _buildClickTrackingLabels(featureTrackingTileLabels: { promo_Source?: string[] }, comboType: string | null): ClickTrackingLabels {
        let attributionSource: string;
        if (featureTrackingTileLabels.promo_Source) {
            attributionSource = featureTrackingTileLabels.promo_Source[0];
        } else {
            attributionSource = "TopicPromotionLarge";
        }

        const pageCluster = window.o_util.misc.getPagecluster();
        const clickTrackingInfo: ClickTrackingLabels = {
            "wk.promo_AttributionFeature": `TopicPromotionLarge_${pageCluster}`,
            "wk.promo_AttributionSource": attributionSource
        }
        if (comboType) {
            clickTrackingInfo.promo_ComboType = comboType;
        }
        return clickTrackingInfo;
    }

    _createTopicPromoFeature(featureOrder: number, featureIndex: number, status: string): Feature {
        return {
            id: `ft3_tpr${featureIndex}`,
            name: "TopicPromotionLarge",
            position: featureOrder,
            status: status,
            labels: {
                promo_Feature: ["true"],
                promo_FilledSlots: ["1"],
                promo_FeatureNumber: [(featureIndex + 1).toString()]
            }
        }
    }

    _createTopicPromoTileFeature(featureIndex: number, featureTrackingTileLabels: FeatureTrackingLabels, status: string): TileFeature {
        return {
            id: "ft3_tpr" + featureIndex + "_tile1",
            parentId: "ft3_tpr" + featureIndex,
            name: "TopicPromotionLarge-Tile",
            status: status,
            labels: featureTrackingTileLabels
        };
    }

}